export default __webpack_public_path__ + "static/media/icontg.c9f20fed.svg";